import React, { useCallback } from 'react';
import { Search } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useCommandMenuToggle } from './AdminCommandMenu.callbacks';
import { setNextOpenTrigger } from './AdminCommandMenu.utils';
import type { CommandMenuSource } from './AdminCommandMenu.types';
import { SearchButtonRoot } from './CommandMenuSearchButton.styles';

type CommandMenuSearchButtonProps = Readonly<{
  /** Identifies where this button lives so telemetry can distinguish entry points. */
  source: CommandMenuSource;
}>;

export const CommandMenuSearchButton: React.FC<CommandMenuSearchButtonProps> = ({ source }) => {
  const toggle = useCommandMenuToggle();
  const { tq } = useTranslation('commandPaletteAdmin');

  const handleClick = useCallback(() => {
    setNextOpenTrigger('button', source);
    toggle?.();
  }, [toggle, source]);

  if (!toggle) return null;

  return (
    <SearchButtonRoot
      type="button"
      onClick={handleClick}
      aria-label={tq`Search pages and actions`}
    >
      <Search size="sm" />
    </SearchButtonRoot>
  );
};

CommandMenuSearchButton.displayName = 'CommandMenuSearchButton';
